import Modal from "@/components/Common/Modal";
import AccountEdit from "@/components/MultiAccount/AccountEdit";
import AccountNotificationPreferences from "@/components/MultiAccount/AccountNotificationPreferences";
import {useIsAgency} from "@/hooks/useUserHooks";
import {editCompanyMemberModalAtom} from "@/store/jotaiAtoms";
import {useAtom} from "jotai";
import {useState, type FC} from "react";
import {useTranslation} from "react-i18next";

const TABS = ["ACCOUNT", "NOTIFICATIONS"] as const;

const EditCompanyMemberModal: FC = () => {
  const {t} = useTranslation("multi_account");
  const isAgency = useIsAgency();
  const [editCompanyMemberModal, setEditCompanyMemberModal] = useAtom(editCompanyMemberModalAtom);
  const [activeTab, setActiveTab] = useState<"ACCOUNT" | "NOTIFICATIONS">("ACCOUNT");

  return (
    <Modal
      backgroundClassName="min-h-[80vh] max-w-[760px] [&>div]:border-0 lg:min-h-[700px]"
      onClose={() => {
        if (editCompanyMemberModal.isRegistering) return;
        setEditCompanyMemberModal({isVisible: false, isRegistering: false});
      }}
      customTitleRow={
        // TODO: Hide temporarly in case of agency
        editCompanyMemberModal.isRegistering || isAgency ? (
          <div className="h-16" />
        ) : (
          <div className="flex items-center gap-5 p-5 sm:gap-10">
            {TABS.map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`border-b-2 pb-1 text-center font-semibold transition ${
                  tab === activeTab
                    ? "border-b-primary-dark-solid text-primary-dark-solid"
                    : "text-neutral-grey-light border-b-transparent"
                }`}>
                {t(tab.toLowerCase())}
              </button>
            ))}
          </div>
        )
      }
      customBottomRow={<></>}
      shouldHideCloseButton={editCompanyMemberModal.isRegistering}>
      {activeTab === "ACCOUNT" && <AccountEdit />}
      {/* TODO: Hide temporarly in case of agency */}
      {!isAgency && activeTab === "NOTIFICATIONS" && <AccountNotificationPreferences />}
    </Modal>
  );
};

export default EditCompanyMemberModal;
